import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { User } from '@/app/shared/interface/user.interface';

@Component({
  selector: 'app-confirmation-address-modal',
  providers: [NgbActiveModal],
  templateUrl: './confirmation-address-modal.component.html',
  styleUrls: ['./confirmation-address-modal.component.scss']
})
export class ConfirmationAddressModalComponent {
  @Input() user: User;


  public closeResult: string;
  public modalOpen: boolean = false;

  @ViewChild("confirmAddressModal", { static: false }) ConfirmationModal: any;


  @Output() confirmed: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId: Object,
    private activeModal: NgbActiveModal
  ) { }

  async openModal() {
    if (isPlatformBrowser(this.platformId)) {
      this.modalOpen = true;
      this.modalService.open(this.ConfirmationModal, {
        ariaLabelledBy: 'Confirmation-Modal',
        windowClass: 'theme-modal'
      }).result.then((result) => {
        `Result ${result}`
        if (result === null) {
          this.confirm(null);
          return;
        }
        this.confirm(true);
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.confirm(false);
      });
    }
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  confirm(value?: any) {
    this.activeModal.dismiss();
    this.confirmed.emit(value);
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.activeModal.dismiss();
    }
  }
}
